var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0147 3.16797C12.3091 2.92776 12.7439 2.94534 13.0186 3.21973C13.293 3.49412 13.3101 3.92806 13.0703 4.22266L13.0186 4.28028L9.31153 7.98926L13.0225 11.6963L13.0742 11.7529C13.3144 12.0474 13.2969 12.4822 13.0225 12.7568C12.7297 13.0496 12.2549 13.0495 11.9619 12.7568L8.25196 9.04981L4.5459 12.7607L4.48926 12.8125C4.1948 13.0527 3.76 13.0351 3.48536 12.7607C3.19258 12.468 3.19268 11.9931 3.48536 11.7002L7.19141 7.99024L3.48145 4.28418L3.42969 4.22754C3.18948 3.93308 3.20706 3.49828 3.48145 3.22364C3.75584 2.94924 4.18978 2.93206 4.48438 3.17188L4.542 3.22364L8.25098 6.92969L11.958 3.21973L12.0147 3.16797Z",
    fill: "#0C121D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.b4800374086e21cdea6dfaa0a4a5701a.svg";
export { ForwardRef as ReactComponent };